var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.625C4.81667 11.625 3.73334 10.875 2.95 9.51667L0.725004 5.65833C-0.0666631 4.3 -0.166663 2.99167 0.425003 1.96667C1.01667 0.941666 2.20834 0.375 3.775 0.375H8.225C9.79167 0.375 10.9833 0.941666 11.575 1.96667C12.1667 2.99167 12.0583 4.30833 11.275 5.66667L9.05 9.525C8.26667 10.875 7.18334 11.625 6 11.625ZM3.775 1.625C2.66667 1.625 1.86667 1.96667 1.50834 2.59167C1.14167 3.21667 1.25 4.08333 1.8 5.03333L4.025 8.89167C4.575 9.85 5.275 10.375 5.99167 10.375C6.70834 10.375 7.40834 9.85 7.95834 8.89167L10.1833 5.03333C10.7333 4.075 10.8417 3.20833 10.4833 2.58333C10.125 1.95833 9.31667 1.61667 8.21667 1.61667H3.775V1.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownWhite);
export default __webpack_public_path__ + "static/media/down-white.74255cde0c2e73d9b44ea08e87964337.svg";
export { ForwardRef as ReactComponent };